import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { A11y, Navigation, Pagination, Autoplay } from "swiper/modules";
import { MdCancel, MdCheckCircle } from "react-icons/md";

import getTagColor from "../get-tag-color";
import TasksCarouselNavButton from "./carousel-nav-btn";

import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";

import "./styles.css";

const TasksCarousel = (props) => {
  const navigate = useNavigate();

  const [currentIndex, setCurrentIndex] = useState(0);

  const handleSlideChange = (swiper) => {
    setCurrentIndex(swiper.activeIndex);
  };

  return (
    <Swiper
      onSlideChange={handleSlideChange}
      modules={[Navigation, Pagination, A11y, Autoplay]}
      spaceBetween={16}
      style={{
        width: "26vw",
        padding: "0.3125em",
        position: "relative",
      }}
      autoplay={{ delay: 10000 }}
      pagination={{
        dynamicBullets: true,
      }}
    >
      {props?.items?.map((item, index) => (
        <SwiperSlide
          key={index}
          className={`font-semibold ${
            item.status === "incomplete" && "cursor-pointer"
          }`}
          onClick={() => item.status !== "complete" && navigate(item?.link)}
        >
          <div className="text-[1.5em] font-bold flex justify-between items-center">
            <div>Task #{index + 1}</div>
            <div
              style={{
                backgroundColor: getTagColor(item.percCompleted),
              }}
              className="text-white text-[0.575em] px-2 py-1 rounded-lg font-semibold capitalize flex gap-1 justify-center items-center"
            >
              {item.percCompleted === 100 ? <MdCheckCircle /> : <MdCancel />}
              <span className="leading-4">{item.percCompleted}%</span>
            </div>
          </div>
          <div className="h-[2.5em]">{item.title}</div>
        </SwiperSlide>
      ))}

      <div className="absolute bottom-3 w-[33.625em]">
        <TasksCarouselNavButton
          index={currentIndex}
          totalSlides={props?.items?.length}
          slidesPerView={1}
        />
      </div>
    </Swiper>
  );
};

export default TasksCarousel;
